import Utils from "@/components/shared/util";
import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class Brain extends mixins(GraphRanges) {
  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("alerts", patientNamespace)
  alerts!: any;

  get charts(): MultiChartConfig[] {
    const chartList: MultiChartConfig[] = [];
    if (this.bisMacData.length) {
      chartList.push({
        title: this.bisMacLabel.join(" / "),
        data: this.bisMacData,
        library: this.bisMacConfig
      });
    }
    return chartList;
  }

  get table() {
    const level = _.get(this, "current.body.atoms.camRass.legend", "")
      .split(",")
      .map((level: string) => +level);

    const cam = _.get(this, "current.body.current.CAM.text");
    const camColor = level[0] === 3 ? null : Utils.getLevelTableColor(level[0]);
    const camAge = _.get(this, "current.body.current.CAM.age");

    let rassLegend = _.get(this, "current.body.current.RASS.text");
    if (rassLegend !== "") {
      const rassValue = _.get(this, "current.body.current.RASS.value");
      rassLegend += ` (${rassValue})`;
    }
    const rassColor =
      level[1] === 3 ? null : Utils.getLevelTableColor(level[1]);
    const rassAge = _.get(this, "current.body.current.RASS.age");

    const gcs = _.get(this, "current.body.current.GCS.text");
    const gcsAge = _.get(this, "current.body.current.GCS.age");

    return [
      { label: "CAM", color: camColor, value: cam, age: camAge },
      {
        label: "RASS",
        color: rassColor,
        value: rassLegend,
        age: rassAge
      },
      { label: "GCS", color: null, value: gcs, age: gcsAge }
    ];
  }

  get tivaAlertText() {
    const defaultText =
      "Pure TIVA documented. NMB given. Consider BIS or nitrous oxide.";

    if (this.alerts != null) return defaultText;

    const tivaAlert = this.alerts.filter((f: any) => f.id === "Tiva");

    return tivaAlert.length > 0 && tivaAlert[0].description !== null
      ? tivaAlert.description
      : "Pure TIVA documented. NMB given. Consider BIS or nitrous oxide.";
  }

  get bisMacData() {
    return this.graph(
      [
        { key: "MAC", label: "MAC", yAxisID: "Left" },
        { key: "BIS", label: "BIS", yAxisID: "Right" }
      ],
      true
    );
  }

  get bisMacLabel() {
    const labels: Array<string> = [];
    this.bisMacData.forEach((d: any) => {
      labels.push(d.label);
    });
    return labels;
  }

  get bisMacConfig() {
    const macScale = {
      id: "Left",
      position: "left",
      type: "linear",
      ticks: {
        suggestedMax: 2,
        min: 0,
        stepSize: 0.5
      }
    };

    const bisScale = {
      id: "Right",
      position: "right",
      type: "linear",
      ticks: {
        min: 0,
        suggestedMax: 100,
        stepSize: 25
      }
    };
    const yAxes: Array<any> = [];

    this.bisMacLabel.forEach((label: string) => {
      switch (label) {
        case "MAC":
          yAxes.push(macScale);
          break;
        case "BIS":
          yAxes.push(bisScale);
          break;
      }
    });

    return { scales: { yAxes } };
  }
}
